import { Link } from 'react-router-dom'
import styled from 'styled-components'
import ButtonV2 from 'components/button-v2'

interface MoreLinkProps {
  to: string
  align?: 'left' | 'center' | 'right'
}

const StyledButton = styled(ButtonV2).attrs({
  as: Link,
})<{ to: string }>`
  font-size: 14px;

  img {
    width: 6px;
    height: 12px;
  }

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    font-size: 12px;
  }
`

const MoreLink = (props: MoreLinkProps) => {
  return (
    <StyledButton to={props.to} variant="secondary" size="full">
      <span>さらに見る</span>
      <img src="/image/arrow-right-navy.svg" alt="more" />
    </StyledButton>
  )
}

export default MoreLink
